import { render, staticRenderFns } from "./CostPerTrip.vue?vue&type=template&id=2a924e8f&"
import script from "./CostPerTrip.vue?vue&type=script&lang=js&"
export * from "./CostPerTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports